import { Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { selectUser } from '../store/account.selectors';
import { Account } from '../account.models';
import { logout } from '../store/account.actions';
import { selectAccounts, selectAccountsIsModalOpenFlag } from '../../settings/store/accounts/accounts.selectors';
import { closeAccountsModal, getAccountsList, openAccountsModal } from '../../settings/store/accounts/accounts.actions';
import { QueryParamsAccountsMenuList } from '../../common/helper/query-params-generic-list.helper';

@Component({
  selector: 'launchpad',
  template: `
    <integrateio-notification></integrateio-notification>
    <div class="app window-container launchpad">
      <p class="lead text-center">{{ 'app.lead' | translate }}</p>
      <div class="panel">
        <div class="panel-heading text-center" *ngIf="user$ | async as user">
          <user-logo [userName]="user.name || user.email"></user-logo>
        </div>
        <div class="panel-body">
          <ul class="list-group accounts-list">
            <xp-loader *ngIf="!(accountsList$ | async)"></xp-loader>
            <li class="list-group-item" *ngFor="let account of accountsList$ | async">
              <a (click)="goToJobs(account)">
                <div class="media">
                  <div class="media-left">
                    <img class="media-object img-circle" [src]="account.avatar_url" [alt]="account.name" />
                  </div>
                  <div class="media-body">
                    <h4 class="media-heading title-only">
                      {{ account.name | xpLengthCheck: 24 }}
                    </h4>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="panel-footer">
          <button class="btn btn-link btn-block" (click)="logout()">{{ 'app.actions.sign_out' | translate }}</button>
          <button class="btn btn-link btn-block new-account" (click)="openNewAccountForm()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 14 14">
              <polygon style="fill: #ffd261;" points="14,6 8,6 8,0 6,0 6,6 0,6 0,8 6,8 6,14 8,14 8,8 14,8 " />
            </svg>
            <span>{{ 'app.actions.new_account' | translate }}</span>
          </button>
        </div>
      </div>
      <help-menu></help-menu>
      <xp-modal
        [isOpen]="isModalOpen$ | async"
        [closeButtonText]="'account.generic-object.buttons.close' | translate"
        [saveButtonText]="'account.generic-object.buttons.save' | translate"
        [titleText]="'account.generic-object.title' | translate"
        [isSmall]="true"
        (close)="onModalClose()"
      >
        <ng-template>
          <account-form></account-form>
        </ng-template>
      </xp-modal>
    </div>
  `,
})
export class LaunchpadComponent {
  user$ = this.store.select(selectUser);
  accountsList$ = this.store.select(selectAccounts);
  isModalOpen$ = this.store.select(selectAccountsIsModalOpenFlag);
  queryParams = { ...QueryParamsAccountsMenuList };

  constructor(private store: Store<AppState>, @Inject('$rootScope') private $rootScope: any) {
    this.store.dispatch(getAccountsList({ params: { ...this.queryParams }, getAll: true }));
  }

  goToJobs(account: Account) {
    this.$rootScope.stateGo('app.account.jobs', { account_id: account.account_id });
  }

  onModalClose(): void {
    this.store.dispatch(closeAccountsModal());
  }

  logout() {
    this.store.dispatch(logout({ shouldRedirect: true }));
  }

  openNewAccountForm() {
    this.store.dispatch(openAccountsModal());
  }
}

((window as any).xplenty as angular.IModule).directive(
  'launchpad',
  downgradeComponent({
    component: LaunchpadComponent,
  }),
);
